import React from "react";
import Header from "../common/header/Header";
import heroImg from "../images/pricing.jpg"; // Use your own image path
import "./contact.css";

const Contact = () => {
  return (
    <>
      <Header />
      <section
        className="contact-hero d-flex align-items-center"
        style={{
          minHeight: "40vh",
          background: `linear-gradient(120deg, #e0eafc 0%, #cfdef3 100%), url(${heroImg}) center/cover no-repeat`,
          position: "relative",
        }}
      >
        <div className="container text-center">
          <h1 className="display-4 fw-bold mb-2" style={{ color: "#222" }}>
            Get in Touch
          </h1>
          <p className="lead" style={{ color: "#444" }}>
            We'd love to hear from you! Fill out the form and our team will get back to you soon.
          </p>
        </div>
      </section>
      <section className="py-5" style={{ background: "#f4f7fa" }}>
        <div className="container">
          <div className="row g-4 justify-content-center align-items-stretch">
            {/* Contact Info */}
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div
                className="contact-info-card h-100 d-flex flex-column justify-content-center align-items-center"
                style={{
                  minHeight: "480px",
                  background: "linear-gradient(135deg, rgba(108,99,255,0.12) 0%, rgba(207,222,243,0.18) 100%)",
                  border: "none",
                  borderRadius: "1.5rem",
                  boxShadow: "0 8px 32px rgba(108,99,255,0.10)",
                  backdropFilter: "blur(6px)",
                  padding: "2.5rem 2rem",
                }}
              >
                <div className="mb-4 text-center">
                  <i className="fa fa-map-marker fa-2x mb-2" style={{ color: "#6c63ff" }}></i>
                  <h6 className="fw-bold">Address</h6>
                  <p className="text-muted small mb-0">
                    Lilongwe Malawi, Area 47 Sector 4, Off Msokela Road, Mazengera Street, Plot # 862
                  </p>
                </div>
                <div className="mb-4 text-center">
                  <i className="fa fa-phone fa-2x mb-2" style={{ color: "#6c63ff" }}></i>
                  <h6 className="fw-bold">Phone</h6>
                  <p className="text-muted small mb-0">
                    <a href="tel:+265999970417" className="text-decoration-none text-dark">
                      +265 999 970 417
                    </a>
                  </p>
                </div>
                <div className="mb-4 text-center">
                  <i className="fa fa-paper-plane fa-2x mb-2" style={{ color: "#6c63ff" }}></i>
                  <h6 className="fw-bold">Email</h6>
                  <p className="text-muted small mb-0">
                    <a href="mailto:info@farmradiomw.org" className="text-decoration-none text-dark">
                      info@farmradiomw.org
                    </a>
                  </p>
                </div>
                <div className="text-center">
                  <i className="fa fa-globe fa-2x mb-2" style={{ color: "#6c63ff" }}></i>
                  <h6 className="fw-bold">Website</h6>
                  <p className="text-muted small mb-0">
                    <a href="https://farmradiomw.org" className="text-decoration-none text-dark">
                      farmradiomw.org
                    </a>
                  </p>
                </div>
              </div>
            </div>
            {/* Contact Form */}
            <div className="col-lg-6">
              <div
                className="contact-form-card h-100"
                style={{
                  minHeight: "480px",
                  background: "rgba(255,255,255,0.98)",
                  border: "none",
                  borderRadius: "1.5rem",
                  boxShadow: "0 8px 32px rgba(108,99,255,0.10)",
                  padding: "2.5rem 2rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <form>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className="form-control modern-input"
                          id="name"
                          placeholder="Full Name"
                          required
                        />
                        <label htmlFor="name">
                          <i className="fa fa-user me-2" style={{ color: "#6c63ff" }}></i>Full Name
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating mb-3">
                        <input
                          type="email"
                          className="form-control modern-input"
                          id="email"
                          placeholder="Email Address"
                          required
                        />
                        <label htmlFor="email">
                          <i className="fa fa-envelope me-2" style={{ color: "#6c63ff" }}></i>Email Address
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className="form-control modern-input"
                          id="subject"
                          placeholder="Subject"
                          required
                        />
                        <label htmlFor="subject">
                          <i className="fa fa-tag me-2" style={{ color: "#6c63ff" }}></i>Subject
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating mb-3">
                        <textarea
                          className="form-control modern-input"
                          placeholder="Message"
                          id="message"
                          style={{ height: "120px" }}
                          required
                        ></textarea>
                        <label htmlFor="message">
                          <i className="fa fa-comment me-2" style={{ color: "#6c63ff" }}></i>Message
                        </label>
                      </div>
                    </div>
                    <div className="col-12 text-end">
                      <button
                        type="submit"
                        className="btn"
                        style={{
                          background: "linear-gradient(90deg, #6c63ff 0%, #1bbd36 100%)",
                          color: "#fff",
                          borderRadius: "2rem",
                          fontWeight: 600,
                          padding: "0.75rem 2.5rem",
                          boxShadow: "0 4px 16px rgba(108,99,255,0.15)",
                          letterSpacing: "1px",
                        }}
                      >
                        <i className="fa fa-paper-plane me-2"></i>Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* Google Map */}
          <div className="row mt-5">
            <div className="col-12">
              <div className="rounded-4 overflow-hidden shadow-sm" style={{ height: "400px" }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3801.532594085601!2d33.76450903585448!3d-13.95157418766667!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1921d343c338032f%3A0xcb4a205a3077c283!2sFarm%20Radio%20Trust%2C%20Malawi!5e1!3m2!1sen!2smw!4v1698071898680!5m2!1sen!2smw"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Farm Radio Trust Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
